function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-868 -869)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 51.5,
  cy: 51.5,
  r: 51.5,
  transform: "translate(868 869)",
  fill: "#f4f4f4"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(899.066 894.389)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M58.515,27.306l-1.39,37.521a1.265,1.265,0,0,1-1.238,1.189H31.878a1.267,1.267,0,0,1-1.238-1.189L29.25,27.306a1.876,1.876,0,1,0-3.748.14l1.39,37.52a5.016,5.016,0,0,0,4.986,4.8H55.887a5.015,5.015,0,0,0,4.986-4.8l1.39-37.52a1.876,1.876,0,0,0-3.748-.14Z",
  transform: "translate(-23.249 -17.997)",
  fill: "#464a55"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48,37.5v25.51a1.5,1.5,0,0,0,3,0V37.5a1.5,1.5,0,0,0-3,0Z",
  transform: "translate(-28.867 -20.619)",
  fill: "#464a55"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37,37.545l.75,25.51a1.5,1.5,0,0,0,3-.089L40,37.456a1.5,1.5,0,1,0-3,.089Z",
  transform: "translate(-26.121 -20.619)",
  fill: "#464a55"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.751,37.456,58,62.966a1.5,1.5,0,0,0,3,.089l.75-25.51a1.5,1.5,0,1,0-3-.089Z",
  transform: "translate(-31.365 -20.619)",
  fill: "#464a55"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.376,27.751H61.891a1.876,1.876,0,0,0,0-3.751H24.376a1.876,1.876,0,1,0,0,3.751Z",
  transform: "translate(-22.5 -17.622)",
  fill: "#464a55"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.2,23.143l.781-2.734a1.818,1.818,0,0,1,1.535-1.158h6.766a1.817,1.817,0,0,1,1.535,1.158l.781,2.734,3.607-1.031-.781-2.733A5.543,5.543,0,0,0,50.286,15.5H43.52a5.544,5.544,0,0,0-5.143,3.879L37.6,22.112Z",
  transform: "translate(-26.27 -15.5)",
  fill: "#464a55"
})));

var SvgRemoveAccountIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRemoveAccountIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/remove-account-icon.bf599a49.svg";
export { ForwardRef as ReactComponent };